import _ from 'underscore';
import classNames from 'classnames';
import React, { useCallback, useContext } from 'react';
import { AdvisorChartWithMetrics, CHART_TYPES } from '@bingads-webui-campaign-react/advisor-chart';
import { Button } from '@fluentui/react-components';
import { ScopeContext } from '@bingads-webui-react/scope-service';

import { ShimmerCard } from './shimmer-card';
import { NoDataCard } from './no-data-card';
import { useCardStyles } from '../styles/card-styles';
import { CompetitionCardProps, IScopeContext } from '../utils/types';

import { withAuctionInsightData } from '../data/with-auction-insight-data';
import { withFilterData } from './with-filter-data';

export function CompetitionCard({
  data,
  isLoading,
  i18n,
  perfMarkerUtils,
  selectedMetric,
  competitors = null,
}: CompetitionCardProps) {
  const styles = useCardStyles();

  const { scope } = useContext(ScopeContext) as IScopeContext;
  // @ts-ignore
  const legacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/dashboard-cards');

  const onClick = useCallback(() => {
    scope.save('/campaign/vnext/competitionauction');
  }, [scope]);

  const {
    willFetchData,
    willRender,
    done,
  } = perfMarkerUtils;

  if (isLoading) {
    willFetchData();
    return (<ShimmerCard />);
  }

  willRender();
  done();

  if (!data?.items?.length) {
    return <NoDataCard i18n={i18n} />;
  }

  return (
    <div className={classNames('ba-competition-card', styles.container)}>
      <AdvisorChartWithMetrics
        i18n={legacyI18n}
        selectedMetric={selectedMetric}
        domains={competitors}
        chartType={CHART_TYPES.SmallTile}
        items={data?.items}
      />
      <div className="footer">
        <Button className="action-button" onClick={onClick}>{i18n.getString(_TL_('Go to Competition tab'))}</Button>
      </div >
    </div >
  );
}

export const CompetitionCardWithData = withAuctionInsightData(withFilterData(CompetitionCard));
